import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ProgressBar from '../../../common/ProgressBar/ProgressBar';
import FileLinkMessage from './FileLinkMessage';
import ClientCode from '../../../../clientCode/ClientCode';
import _ from 'lodash';


class DocketDetailsPurchaseForm extends Component {
  renderProgress = percentage => (
    <div>
      <ProgressBar percentage={percentage || 5} show />
    </div>
  )

  render() {
    const { docketParts } = this.props;
    const {
      partsToPurchase,
      totalCost,
      totalParts,
      percentage,
      errors,
      step,
      status,
      purchased,
      alreadyPurchased,
      link,
    } = docketParts;

    let step2 = null;

    if (step === 2 || step === 3) {
      step2 = (alreadyPurchased)
        ? (<div>Already Purchased </div>)
        : (
          <div>
            { step === 2 && status !== 'done' && this.renderProgress(percentage) }
          </div>
        );
    }

    const partsOrLoading = ((step === 1 || step === 0) && status === 'loading')
      ? this.renderProgress(percentage)
      : (
        <div id="progress1" className="batch-processed">
          Need to purchase { partsToPurchase } / { totalParts } PDFs from PACER.
          {step === 1 && partsToPurchase > 0 && (
            <div>
              <div>
                <ClientCode
                  initialClientCode=""
                  isClientCodeLocked={ _.get(window, 'Drupal.settings.isClientCodeLocked') }
                  className="purchase-popup" ignoreClientCodeAutosetMsg
                />
              </div>
              <button className="form-submit green next buy-btn" onClick={this.props.buy}>
                Buy ${(totalCost || 0).toFixed(2)}
              </button>
            </div>)
          }
        </div>
      );

    return (
      <div className="inner-text">
        { this.props.showXfaWarning &&
          <div className="warning">
            PDF combining currently does not support XFA documents.
          </div>
        }
        {
          // if there are any errors, show them.
          errors && (
            <div className="error">
              {errors.map((error) => <span>{error}<br/></span>)}
            </div>
          )
        }
        <ol>
          <li className="">
            Checking price of all dockets
            { partsOrLoading }
          </li>
          <li className={(step === 1) ? 'pending' : ''}>
            Purchasing dockets
            { step2 }
            {(purchased > 0) && (<div>Purchased {purchased} PDFs</div>)}
          </li>
          <li className={(step === 3) ? '' : this.props.hidePendingSteps ? 'hide' : 'pending'}>
            Combining
            {(step === 3 && status !== 'done') && (
              this.renderProgress(percentage)
            )}
            { link && <FileLinkMessage link={link} /> }
          </li>
        </ol>

      </div>
    );
  }
}

DocketDetailsPurchaseForm.defaultProps = {
  showXfaWarning: false,
}

DocketDetailsPurchaseForm.propTypes = {
  docketParts: PropTypes.object.isRequired,
  buy: PropTypes.func.isRequired,
  showXfaWarning: PropTypes.bool,
  hidePendingSteps: PropTypes.bool,
};

export default DocketDetailsPurchaseForm;



// WEBPACK FOOTER //
// ./src/components/case/docket/popups/DocketDetailsPurchaseForm.jsx